import * as Yup from 'yup';
import { checkIfValidUUID } from './checkout-helpers';

// const phoneRegexp =
//   /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const VALIDATION_SCHEMA = Yup.object().shape({
  mid: Yup.string()
    .required('UUID is required')
    .test('is-valid-uuid', 'Invalid UUID', value => {
      if (!value) return false;
      return checkIfValidUUID(value);
    }),
  appKey: Yup.string().required(),
  appSecret: Yup.string().required(),
  spreedlyKey: Yup.string().required(),
  billingFirstName: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('First name is required'),
  billingLastName: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Last name is required'),
  billingAddressLine1: Yup.string().min(3, 'Minimum 3 symbols').required('Billing address is required'),
  billingCity: Yup.string().min(3, 'Minimum 3 symbols').required('City is required'),
  billingZip: Yup.string().min(3, 'Minimum 3 symbols').required('zip is required'),
  billingCountry: Yup.string().min(2, 'Minimum 2 symbols').max(3, 'Maximum 3 symbols').required('Country is required'),
  phone: Yup.string()
    // .matches(phoneRegexp, 'Phone number is not valid')
    .required('Phone is required'),
  email: Yup.string().email('Wrong email format').min(5, 'Minimum 5 symbols').required('Email is required'),
  cardName: Yup.string().min(3, 'Minimum 3 symbols').required('Card name is required'),
  state: Yup.string().when('billingCountry', {
    is: (billingCountry: string) => {
      return billingCountry === 'USA';
    },
    then: Yup.string().required('Billing address is required'),
  }),
  cardNumber: Yup.string().required('Card number is required'),
  expirationYear: Yup.string().min(4, 'Minimum 4 symbols').max(4, 'Maximum 4 symbols').required('Year is required'),
  expirationMonth: Yup.string().min(1, 'Minimum 4 symbols').max(2, 'Maximum 4 symbols').required('Month is required'),
  cvv: Yup.string().min(3, 'Minimum 4 symbols').max(4, 'Maximum 4 symbols').required('Cvv is required'),
});
